
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/bon-dia",
      function () {
        return require("private-next-pages/corporatiu/bon-dia/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/bon-dia"])
      });
    }
  